module.exports = require("@nestjs/sequelize");